import React from "react";

const IntuitiveApi = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2565_1843)">
      <path
        d="M16.5559 3.84305L20.1579 7.44505C20.4251 7.71221 20.637 8.02939 20.7816 8.37847C20.9262 8.72755 21.0007 9.1017 21.0007 9.47955C21.0007 9.8574 20.9262 10.2316 20.7816 10.5806C20.637 10.9297 20.4251 11.2469 20.1579 11.5141L17.5149 14.1571C17.2477 14.4243 16.9305 14.6362 16.5814 14.7808C16.2324 14.9254 15.8582 14.9999 15.4804 14.9999C15.1025 14.9999 14.7284 14.9254 14.3793 14.7808C14.0302 14.6362 13.713 14.4243 13.4459 14.1571L13.1449 13.8561L6.58685 20.4141C6.25457 20.7463 5.81593 20.9509 5.34785 20.9921L5.17285 21.0001H4.00085C3.75592 21 3.51952 20.9101 3.33648 20.7473C3.15345 20.5846 3.03651 20.3603 3.00785 20.1171L3.00085 20.0001V18.8281C3.00097 18.3585 3.16629 17.904 3.46785 17.5441L3.58685 17.4141L4.00085 17.0001H6.00085V15.0001H8.00085V13.0001L10.1449 10.8561L9.84385 10.5551C9.57665 10.2879 9.3647 9.97071 9.22009 9.62163C9.07548 9.27255 9.00105 8.8984 9.00105 8.52055C9.00105 8.1427 9.07548 7.76855 9.22009 7.41947C9.3647 7.07039 9.57665 6.75321 9.84385 6.48605L12.4869 3.84305C12.754 3.57585 13.0712 3.36389 13.4203 3.21928C13.7694 3.07467 14.1435 3.00024 14.5214 3.00024C14.8992 3.00024 15.2734 3.07467 15.6224 3.21928C15.9715 3.36389 16.2887 3.57585 16.5559 3.84305Z"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0005 8.99976H15.0105"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2565_1843">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IntuitiveApi;
